import React, { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FBOSearchPost, contractOpportunititesPost, futureOpportunitiesSearchPost, businessSearchPost, purchaseSearchPost } from '../../api';
import { UserContext } from '../../context/User';
import { useHistory } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import { somethingWentWrongNotice } from '../UI/Notifications';
import { 
  FEDERAL_OPPORTUNITIES_GET_SELECT, 
  CONTRACT_OPPORTUNITIES_POST_SELECT, 
  BUSINESSES_GET_SELECT, 
  FUTURE_OPPORTUNITIES_GET_SELECT,
  PURCHASES_GET_SELECT 
} from '../../constans';
import { SearchContext } from '../../context/Search';
import SearchSettings from "../SearchSettings";
import TableContainer from "../TableContainer";
import Pagination from "../Pagination";
import PageSwitcher from "../PageSwitcher";
import Loading from '../Loading';

const REQUESTS = {
  contract_opportunities: FBOSearchPost,
  b2b_opportunities: purchaseSearchPost,
  future_opportunities: futureOpportunitiesSearchPost,
  businesses: businessSearchPost,
  micro_purchases: contractOpportunititesPost
}

const AdvancedResults = () => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [offset, setOffset] = useState(0);
  const [active, setActive] = useState("");
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [searchedData, setSearchedData] = useState([]);
  const [forcePage, setForcePage] = useState(0);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();
  const [sorted, setSorted] = useState(false);
  const [orderByParams, setOrderByParams] = useState([]);
  const qs = require('qs');

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Search");
    }

    setLoading(false);
  }


  const setSelect = (entity) => {
    let selects = [];

    switch (entity) {
      case "contract_opportunities":
        selects = FEDERAL_OPPORTUNITIES_GET_SELECT
        break;
      case "b2b_opportunities":
        selects = PURCHASES_GET_SELECT
        break;
      case "future_opportunities":
        selects = FUTURE_OPPORTUNITIES_GET_SELECT 
        break;
      case "businesses":
        selects = BUSINESSES_GET_SELECT 
        break;
      case "micro_purchases":
        selects = CONTRACT_OPPORTUNITIES_POST_SELECT 
        break;
      default:
    }

    return selects;
  }
  
  const dataStructuring = (fullTextParams, queryParams, entity) => {
    setLoading(true);

    if (!fullTextParams.search) delete fullTextParams.search;

    delete queryParams.search;
    delete queryParams.entity;

    requestHandler(fullTextParams, qs.parse(queryParams), entity);
  }

  const searchHandler = (queryParams, entity) => {
    const fullTextParams = {
      limit: limit,
      offset: offset,
      select: setSelect(entity),
      search: queryParams.search ? queryParams.search : ""
    };

    dataStructuring(fullTextParams, queryParams, entity);
  }

  const sortHandler = (queryParams, entity, sort_by) => {
    const fullTextParams = {
      limit: limit,
      offset: offset,
      select: setSelect(entity),
      order_by: sort_by && sort_by,
      search: queryParams.search ? queryParams.search : ""
    };

    if (!fullTextParams.order_by) delete fullTextParams.order_by;

    dataStructuring(fullTextParams, queryParams, entity);
  }
  
  useEffect(() => {
    let queryParams = {};

    query.forEach((value, key) => {
      queryParams[key] = query.getAll(key).length !== 1 ? 
      query.getAll(key): 
      query.get(key);
    });

    for (let prop in queryParams) {
      if (queryParams[prop] === 'false') {
        queryParams[prop] = false
      } else if (queryParams[prop] === 'true') {
        queryParams[prop] = true
      }
    }

    const entity = queryParams.entity;
    setActive(entity);

    if (sorted) sortHandler(queryParams, entity, orderByParams);
    if (!sorted) searchHandler(queryParams, entity);
  }, [limit, offset, orderByParams])
  
  const requestHandler = (fullTextParams, data, entity) => {
    console.log('full',fullTextParams)
    console.log('data',data)

    REQUESTS[entity](fullTextParams, data)
    .then(response => {
      setSearchedData(response.data.results);
      setTotalCount(response.data.total_count);
      setSorted(false);
      setLoading(false);
    })
    .catch(error => {
      error.response.status === 404 ? 
      setSearchedData([]) : 
      handleDefaultStatusCodes(error.response.status); 
      setLoading(false);
    })
  }

  return (
    <Container>
      <Row>
        <Col>
          {!searchedData.length && (
            <h3 className="my-5">No results</h3>
          )}
          <SearchContext.Provider value={{
            setOrderByParams,
            orderByParams,
            setSorted,
            sorted,
            setSearchedData,
            searchedData,
            totalCount,
            limit,
            offset,
            setLimit,
            setOffset,
            forcePage,
            setForcePage,
            pageCount,
            setPageCount,
            loading,
            active
          }}>
            {!!searchedData && !!searchedData.length && (
              <>
                <SearchSettings />
                <TableContainer />
              </>
            )}
            {searchedData && !!searchedData.length && !!totalCount && (
              <div className="pagination-wrap">
                <Pagination />
                <PageSwitcher />
              </div>
            )}
          </SearchContext.Provider>
          {loading && <Loading />}
        </Col>
      </Row>
    </Container>
  );
};

export default AdvancedResults;